import React, { Component } from 'react'

export default class searchGray extends Component {
    render() {
        return (
         
<svg className={this.props.className} onClick={this.props.onClick} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.47315 16.9448C13.6005 16.9448 16.9463 13.5993 16.9463 9.47242C16.9463 5.34552 13.6005 2 9.47315 2C5.34584 2 2 5.34552 2 9.47242C2 13.5993 5.34584 16.9448 9.47315 16.9448Z" stroke="#73706E" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M18.0006 18.0002L14.75 14.75" stroke="#73706E" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

        )
    }
}
